import { useEffect, useState } from 'react';

export const useDevice = () => {
   const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);

   useEffect(() => {
      const handleResize = () => {
         setIsMobile(window.innerWidth <= 900);
      };
      window.addEventListener('resize', handleResize);
      return () => {
         window.removeEventListener('resize', handleResize);
      };
   }, [window.innerWidth]);

   return { isMobile };
};
